import React, { FC, useState, useRef, useEffect } from 'react';

interface Option {
	value?: string;
	label: string;
}

interface SelectInputProps {
	width: number;
	title?: string;
	mandatory?: boolean;
	placeholder?: string;
	options: Option[];
	value: string;
	onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
	disabled?: boolean;
	wrong?: boolean;
	wrongMessage?: string;
}


const SelectInputMobile: FC<SelectInputProps> = ({
	width,
	title,
	mandatory,
	placeholder,
	options,
	value,
	onChange,
	disabled,
	wrong,
	wrongMessage,
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const [hoveredOption, setHoveredOption] = useState<string | null>(null);
	const ref = useRef<HTMLDivElement>(null);
	const isPlaceholderSelected = value === '';
	
	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (ref.current && !ref.current.contains(event.target as Node)) {
				setIsOpen(false);
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);
	
	const handleOptionClick = (optionValue: string) => {
		if (disabled) return;
		
		const event = {
			target: {
				value: optionValue,
			},
		} as React.ChangeEvent<HTMLSelectElement>;
		onChange(event);
		setIsOpen(false);
	};
	
	const selectedOption = options.find((option) => option.value === value);
	
	return (
		<div style={{ width: width, position: 'relative' }} ref={ref}>
			{title && (
				<div
					style={{
						marginBottom: 3,
						marginLeft: 6,
						fontWeight: 600,
						fontSize: 12,
						color: '#323E48',
					}}
				>
					{title} {mandatory && '*'}
				</div>
			)}
			<div
				style={{
					height: 26,
					background: disabled ? '#EDEDED' : '#FFFFFF',
					boxShadow: '0px 1px 6px #00000029',
					borderRadius: 5,
					border: wrong ? '2px solid red' : '1px solid #00000029',
					display: 'flex',
					alignItems: 'center',
					padding: '0 12px',
					boxSizing: 'border-box',
					cursor: disabled ? 'not-allowed' : 'pointer',
				}}
				onClick={() => !disabled && setIsOpen(!isOpen)}
			>
				<div
					style={{
						fontSize: 13,
						marginLeft: 4,
						color: isPlaceholderSelected ? '#c7cad9' : '#323E48',
						flex: 1,
					}}
				>
					{isPlaceholderSelected
						? placeholder || 'Sélectionnez une option'
						: selectedOption?.label}
				</div>
				<img
					src="/images/chevron-down.svg"
					alt="icon"
					style={{ marginLeft: 0, width: 12, height: 12 }}
				/>
			</div>
			{isOpen && !disabled && (
				<div
					style={{
						position: 'absolute',
						top: 43,
						left: 0,
						width: '100%',
						background: '#FFFFFF',
						boxShadow: '0px 1px 6px #00000029',
						borderRadius: 5,
						zIndex: 1000,
						maxHeight: 200,
						overflowY: 'auto',
					}}
				>
					{options.filter((option) => option.label.length !== 0).map((option) => (
						<div
							key={option.value}
							onClick={() => handleOptionClick(option.value || '')}
							onMouseEnter={() => setHoveredOption(option.value || '')}
							onMouseLeave={() => setHoveredOption(null)}
							style={{
								padding: '10px 14px',
								cursor: 'pointer',
								backgroundColor:
									option.value === value
										? '#EDEDED'
										: option.value === hoveredOption
											? '#FF4C00'
											: 'transparent',
								color:
									option.value === value
										? '#323E48'
										: option.value === hoveredOption
											? '#FFFFFF'
											: '#323E48',
								fontSize: 13,
							}}
						>
							{option.label}
						</div>
					))}
				</div>
			)}
			{wrong && (
				<div
					style={{
						position: 'absolute',
						bottom: -18,
						left: 6,
						fontSize: 10,
						color: 'red',
					}}
				>
					{wrongMessage}
				</div>
			)}
		</div>
	);
};

export default SelectInputMobile;
